<script lang="ts">
    import type {MessageAnimatedEmoji} from "./Types";
    export let entity: MessageAnimatedEmoji
</script>
{entity.emoji}
